import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api } from "@/admin/api";

const inputClass =
  "w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-base text-[#0F172A] placeholder:text-slate-400 outline-none transition-all focus:border-[#0FA89E] focus:ring-4 focus:ring-[rgba(15,168,158,0.1)]";

export const PasswordChange = () => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error("New passwords do not match.");
      return;
    }
    setSaving(true);
    try {
      await api("/api/admin/change-password", {
        method: "POST",
        body: JSON.stringify({ current_password: current, new_password: next }),
      });
      toast.success("Password changed. Use it next time you sign in.");
      setCurrent("");
      setNext("");
      setConfirm("");
    } catch (err) {
      toast.error(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-password-change" className="max-w-lg">
      <h2 className="font-display text-xl font-semibold text-[#0F172A] mb-6">
        Change password
      </h2>
      <form onSubmit={submit} className="rounded-xl border border-slate-200 bg-white p-7 space-y-5">
        <div>
          <label className="block text-sm font-semibold text-slate-700 mb-1.5">Current password</label>
          <input
            type="password"
            required
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            data-testid="password-current-input"
            className={inputClass}
            placeholder="••••••••"
          />
        </div>
        <div>
          <label className="block text-sm font-semibold text-slate-700 mb-1.5">New password</label>
          <input
            type="password"
            required
            minLength={8}
            value={next}
            onChange={(e) => setNext(e.target.value)}
            data-testid="password-new-input"
            className={inputClass}
            placeholder="At least 8 characters"
          />
        </div>
        <div>
          <label className="block text-sm font-semibold text-slate-700 mb-1.5">Confirm new password</label>
          <input
            type="password"
            required
            minLength={8}
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            data-testid="password-confirm-input"
            className={inputClass}
            placeholder="Repeat the new password"
          />
        </div>
        <button
          type="submit"
          data-testid="password-save-button"
          disabled={saving}
          className="w-full inline-flex items-center justify-center gap-2.5 rounded-full bg-[#0FA89E] px-8 py-3.5 text-base font-semibold text-white hover:bg-[#0C8E85] disabled:opacity-60"
        >
          {saving ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              Updating...
            </>
          ) : (
            "Update password"
          )}
        </button>
      </form>
    </div>
  );
};
